import React, { useState } from 'react';
import { Modal } from '../../components';
import { Spinner } from '@swegon-core/ui-components';

export const ValidatingModal = (props) => {
    const { show, itemsToValidate, onValidateItem, itemsValidated } = props;
    const [startValidation, setStartValidation] = useState(false);

    React.useEffect(() => {
        setStartValidation(false);
    }, [itemsToValidate]);

    const handleValidateItems = () => {
        setStartValidation(true);
        onValidateItem();
    };

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="p-4 min-w-min ml-4 mr-4 mt-2">
                <div className="mt-2 mb-2 px-2">
                    <div>
                        {startValidation
                            ? `Validating ${itemsValidated} of ${itemsToValidate.length}`
                            : `${itemsToValidate.length} items waiting to be validate`}
                    </div>
                </div>
                <div className="px-4 sm:flex mb-4 justify-center">
                    {startValidation && <Spinner color="green" />}
                </div>
                <div className="px-4 py-3 sm:flex sm:px-6 justify-end">
                    <button
                        onClick={handleValidateItems}
                        type="button"
                        className="swegon-like-button contained !px-4"
                        disabled={startValidation}
                    >
                        Validate
                    </button>
                </div>
            </div>
        </Modal>
    );
};
